import React from "react";
import { Link } from "react-router-dom";
// reactstrap components
import { Button, Container, Row, Col } from "reactstrap";

export default function Examples() {
  return (
    <div
      className="section section-examples"
      data-background-color="black"
      id="examples-section"
    >
      <img
        alt="..."
        className="path"
        src={require("assets/img/path1.png").default}
      />
      <Container className="text-center">
        <Row>
          <Col sm="6">
            <a
              href="https://docs.google.com/forms/d/1Fsu44_da7UcXUB9JV0NDlY1WhlXR6YPnOsHbATCHgWg/edit"
              target="_blank"
            >
              <img
                alt="..."
                className="img-raised"
                src="https://cdn.discordapp.com/attachments/820937424615768074/969957751943987230/lol_2.jpg"
              />
            </a>
          </Col>
          <Col sm="6">
            <a
              href="https://docs.google.com/forms/d/1paD-b84GwEtTkQnn5II52BOaaZqb4epMNq4CFewaxGg/edit"
              target="_blank"
            >
              <img
                alt="..."
                className="img-raised"
                src="https://cdn.discordapp.com/attachments/820937424615768074/969961987478011956/lol_5_na_5.jpg"
              />
            </a>
          </Col>
        </Row>
        <br />
        <Row>
          <Col sm="6">
            <a
              href="https://docs.google.com/forms/d/1kQFcIac-79ZF3DFk2NyemCguMWcLczGp1FmnJMv2nqg/edit"
              target="_blank"
            >
              <img
                alt="..."
                className="img-raised"
                src="https://cdn.discordapp.com/attachments/820937424615768074/969969464240136202/Untitled-2.jpg"
              />
            </a>
          </Col>
          <Col sm="6">
            <a
              href="https://docs.google.com/forms/d/1TQ7YdoulyU0oXnEHmD318Ivgv4beHKIXhY9RM73JU48/edit"
              target="_blank"
            >
              <img
                alt="..."
                className="img-raised"
                src="https://cdn.discordapp.com/attachments/820937424615768074/969968632782270484/Untitled-1.jpg"
              />
            </a>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
